<template>
  <div class="account-app container_ inner-app">
    <AccountPage class="inner-app-content"/>
    <transition name="modal-fade">
      <Modal v-if="isModalRoute" @close="closeModal" :showCloseBtn="true" :fullScreen="true">
        <router-view />
      </Modal>
    </transition>
    <Loader v-if="isLoading && false"/>
  </div>
</template>

<script>
import Loader from '@/apps/common/modules/common/cmps/Loader.vue'
import Modal from '@/apps/common/modules/common/cmps/Modal.vue'
import AccountPage from './views/AccountPage.vue'

export default {
  name: 'AccountApp',
  data() {
    return {
      prevRoleType: null
    }
  },
  computed: {
    isLoading() {
      return this.$store.getters['account/isLoading']
    },
    isModalRoute() {
      return this.$route.meta.isModal
    }
  },
  watch: {
    isModalRoute: {
      immediate: true,
      handler(isModal) {
        if (isModal) {
          this.prevRoleType = this.$route.query.roleType;
        } else {
          this.prevRoleType = null;
        }
      }
    }
  },
  methods: {
    closeModal() {
      this.$router.push({ name: 'AccountPage', params: { organizationId: this.$route.params.organizationId }, query: { roleType: this.prevRoleType } });
    }
  },
  components: {
    Loader,
    Modal,
    AccountPage
  }
}
</script>

<style lang="scss">
.modal-fade-enter-active, .modal-fade-leave-active {
  transition: opacity 0.2s;
}
.modal-fade-enter, .modal-fade-leave-to {
  opacity: 0;
}
</style>